import React, { Component } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

class LiveTVChannelList extends Component {

    render() {
        if (this.props.channels.loading) {
            return 'Loading...';
        }
        if (this.props.channels.error) {
            return 'Error fetch data';
        }
        const channels = this.props.channels.channels;
        const channelsElement = channels.map(channel => {
            return (
                <div key={channel.id} className="unit">
                    <Link to={`/livetv/${channel.slug}`}>
                        <div className="img">
                            <img src={channel.thumbnail} alt={channel.name} className="img-responsive" />
                            <img src={channel.logo} style={channel.logo === '/images/no-logo.png' ? {height: '125px'}: {}} alt={channel.name} className="logo" />
                        </div>
                    </Link>
                    <div className="name">
                        <Link to={`/livetv/${channel.slug}`}>{ channel.description }</Link>
                    </div>
                </div>
            );
        })

        let settings = {
            dots: false,
            infinite: true,
            speed: 100,
            slidesToShow: 6,
            slidesToScroll: 6
        };

        if (channels.length < 6) {
            settings = {
                dots: false,
                infinite: true,
                speed: 100,
                slidesToShow: channels.length,
                slidesToScroll: channels.length
            };
        }

        return (
            <div className="main-tv">
                <div className="container">
                    <div className="form-group">
                        <h3 className="text-white RobotoLight title">Kênh TV</h3>
                        <div className="block-index-common main-slick">
                            <Slider {...settings}>
                                {channelsElement }
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LiveTVChannelList



// WEBPACK FOOTER //
// ./src/components/LiveTV/LiveTVChannelList.js